import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Actions
import {
    requestloadReportsHarvestInspections,
    requestPollingReportsHarvestInspections,
    canceledPollingReportsHarvestInspections
} from 'services/reportsHarvestInspections/actions';

// Selectors
import { selectCurrentEntityId } from 'services/currentEntityId/selectors';
import { selectCurrentSeasonId } from 'services/currentSeasonId/selectors';
import {
    selectTimePickerFromDate,
    selectTimePickerToDate
} from 'workspaces/react-router-selectors';

interface Props {
    time?: string;
    currentSeasonId?: number;
    currentEntityId?: ?number;
    requestloadReportsHarvestInspections: Function;
    requestPollingReportsHarvestInspections: Function;
    canceledPollingReportsHarvestInspections: Function;
    timePickerFromDate?: string;
    timePickerToDate?: string;
}

export class ReportsHarvestInspectionsRequest extends React.PureComponent<Props> {
    componentDidMount() {
        this.requestloadReportsHarvestInspections();
        this.props.requestPollingReportsHarvestInspections();
    }

    componentDidUpdate(prevProps: Props) {
        // Update if current season changes
        if (
            prevProps.currentSeasonId !== this.props.currentSeasonId ||
            prevProps.currentEntityId !== this.props.currentEntityId ||
            prevProps.timePickerFromDate !== this.props.timePickerFromDate ||
            prevProps.timePickerToDate !== this.props.timePickerToDate
        ) {
            this.requestloadReportsHarvestInspections();
        }
    }

    componentWillUnmount() {
        this.props.canceledPollingReportsHarvestInspections();
    }

    requestloadReportsHarvestInspections = () => {
        const { currentSeasonId } = this.props;
        if (currentSeasonId) {
            this.props.requestloadReportsHarvestInspections();
        }
    };

    render() {
        return null;
    }
}

const mapStateToProps = createStructuredSelector({
    currentEntityId: selectCurrentEntityId,
    currentSeasonId: selectCurrentSeasonId,
    timePickerFromDate: selectTimePickerFromDate,
    timePickerToDate: selectTimePickerToDate
});

export default connect(
    mapStateToProps,
    {
        requestloadReportsHarvestInspections,
        requestPollingReportsHarvestInspections,
        canceledPollingReportsHarvestInspections
    }
)(ReportsHarvestInspectionsRequest);
